module.exports = __webpack_public_path__ + "static/img/44.387d8ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/44.png
// module id = LoGi
// module chunks = 1